import reduxStore from "../../configureEnvStore";
import { EVENT_NAME } from "../../constants/GTagConstants";
import { GLOBAL_MEETING_DATA } from "../../constants/PublicVariables";
import { setCallParticipants } from "../../reducers/common-reducer";
import {
    setConfirmMediateTheCall,
    setMediate,
    setIsSkipSurveyForFirstTimeSOToMediator,
    setSilentUserConnectTheCall,
} from "../../reducers/silentObserver-reducer";
import { LogFirebase } from "../../services/firestore";
import googleEvent from "../../services/googleEvent";
import { isSilentObserver } from "../../shared/utility";
import { handleEndCallFunc } from "../Twilio/Room/roomFunction";

let silentObserverTimer = null;

export const closeSilentObserverPopup = (forced) => {
    if (forced) {
        clearTimeout(silentObserverTimer);
        reduxStore.dispatch(setSilentUserConnectTheCall(false));
    } else {
        /**hide the msg info popup after 7seconds */
        silentObserverTimer = setTimeout(() => {
            const { isRemoteParticipantJoined } = reduxStore.getState().commonReducer;
            if (isRemoteParticipantJoined) {
                //so that fadeout effect can be seen
                clearTimeout(silentObserverTimer);
                reduxStore.dispatch(setSilentUserConnectTheCall(false));
            }
        }, 10000);
    }
};
let silentUsercount = 0;
export const showSilentObserverInParticipantList = (identity) => {
    const { callParticipants } = reduxStore.getState().commonReducer;
    if (GLOBAL_MEETING_DATA.isAgent) {
        if (isSilentObserver(identity)) {
            const updatedParticipants = callParticipants.map((user) => {
                if (user.identity == identity) {
                    silentUsercount++;
                    return {
                        ...user,
                        isSilentObserver: true,
                        isSilentObserverindex: silentUsercount,
                    };
                }
                return user;
            });
            reduxStore.dispatch(setCallParticipants(updatedParticipants));
        }
    }
};

export const callEndWithMediate = (fromWhere) => {
    if (fromWhere == "endCallWithMediate") {
        googleEvent.logEvent(EVENT_NAME.MEDIATE_TAPPED);
        reduxStore.dispatch(setConfirmMediateTheCall(false)); // midate popup variable
        handleEndCallFunc(true); // true for pass from mediate to the end call
        reduxStore.dispatch(setMediate(true));
        reduxStore.dispatch(setIsSkipSurveyForFirstTimeSOToMediator(true));
        LogFirebase("SilentObserver", "ClickOnConfirmMediate", "");
    } else if (fromWhere == "confirmMediate") {
        reduxStore.dispatch(setConfirmMediateTheCall(true));
        LogFirebase("SilentObserver", "ClickOnMediateButton", "");
    }
};
